import React from 'react'

export default ({ ...props }) => (
  <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M46.25 5H40V3.75C40 3.06 39.44 2.5 38.75 2.5C38.06 2.5 37.5 3.06 37.5 3.75V5H12.5V3.75C12.5 3.06 11.94 2.5 11.25 2.5C10.56 2.5 10 3.06 10 3.75V5H3.75C1.6825 5 0 6.6825 0 8.75V43.75C0 45.8175 1.6825 47.5 3.75 47.5H46.25C48.3175 47.5 50 45.8175 50 43.75V8.75C50 6.6825 48.3175 5 46.25 5ZM3.75 7.5H10V11.25C10 11.94 10.56 12.5 11.25 12.5C11.94 12.5 12.5 11.94 12.5 11.25V7.5H37.5V11.25C37.5 11.94 38.06 12.5 38.75 12.5C39.44 12.5 40 11.94 40 11.25V7.5H46.25C46.94 7.5 47.5 8.06 47.5 8.75V15H2.5V8.75C2.5 8.06 3.06 7.5 3.75 7.5ZM46.25 45H3.75C3.06 45 2.5 44.44 2.5 43.75V17.5H47.5V43.75C47.5 44.44 46.94 45 46.25 45Z'
      fill='black'
    />
    <path
      d='M18.75 25H16.25C15.56 25 15 24.44 15 23.75C15 23.06 15.56 22.5 16.25 22.5H18.75C19.44 22.5 20 23.06 20 23.75C20 24.44 19.44 25 18.75 25Z'
      fill='black'
    />
    <path
      d='M26.25 25H23.75C23.06 25 22.5 24.44 22.5 23.75C22.5 23.06 23.06 22.5 23.75 22.5H26.25C26.94 22.5 27.5 23.06 27.5 23.75C27.5 24.44 26.94 25 26.25 25Z'
      fill='black'
    />
    <path
      d='M33.75 25H31.25C30.56 25 30 24.44 30 23.75C30 23.06 30.56 22.5 31.25 22.5H33.75C34.44 22.5 35 23.06 35 23.75C35 24.44 34.44 25 33.75 25Z'
      fill='black'
    />
    <path
      d='M41.25 25H38.75C38.06 25 37.5 24.44 37.5 23.75C37.5 23.06 38.06 22.5 38.75 22.5H41.25C41.94 22.5 42.5 23.06 42.5 23.75C42.5 24.44 41.94 25 41.25 25Z'
      fill='black'
    />
    <path
      d='M11.25 30H8.75C8.06 30 7.5 29.44 7.5 28.75C7.5 28.06 8.06 27.5 8.75 27.5H11.25C11.94 27.5 12.5 28.06 12.5 28.75C12.5 29.44 11.94 30 11.25 30Z'
      fill='black'
    />
    <path
      d='M18.75 30H16.25C15.56 30 15 29.44 15 28.75C15 28.06 15.56 27.5 16.25 27.5H18.75C19.44 27.5 20 28.06 20 28.75C20 29.44 19.44 30 18.75 30Z'
      fill='black'
    />
    <path
      d='M26.25 30H23.75C23.06 30 22.5 29.44 22.5 28.75C22.5 28.06 23.06 27.5 23.75 27.5H26.25C26.94 27.5 27.5 28.06 27.5 28.75C27.5 29.44 26.94 30 26.25 30Z'
      fill='black'
    />
    <path
      d='M33.75 30H31.25C30.56 30 30 29.44 30 28.75C30 28.06 30.56 27.5 31.25 27.5H33.75C34.44 27.5 35 28.06 35 28.75C35 29.44 34.44 30 33.75 30Z'
      fill='black'
    />
    <path
      d='M41.25 30H38.75C38.06 30 37.5 29.44 37.5 28.75C37.5 28.06 38.06 27.5 38.75 27.5H41.25C41.94 27.5 42.5 28.06 42.5 28.75C42.5 29.44 41.94 30 41.25 30Z'
      fill='black'
    />
    <path
      d='M11.25 35H8.75C8.06 35 7.5 34.44 7.5 33.75C7.5 33.06 8.06 32.5 8.75 32.5H11.25C11.94 32.5 12.5 33.06 12.5 33.75C12.5 34.44 11.94 35 11.25 35Z'
      fill='black'
    />
    <path
      d='M18.75 35H16.25C15.56 35 15 34.44 15 33.75C15 33.06 15.56 32.5 16.25 32.5H18.75C19.44 32.5 20 33.06 20 33.75C20 34.44 19.44 35 18.75 35Z'
      fill='black'
    />
    <path
      d='M26.25 35H23.75C23.06 35 22.5 34.44 22.5 33.75C22.5 33.06 23.06 32.5 23.75 32.5H26.25C26.94 32.5 27.5 33.06 27.5 33.75C27.5 34.44 26.94 35 26.25 35Z'
      fill='black'
    />
    <path
      d='M33.75 35H31.25C30.56 35 30 34.44 30 33.75C30 33.06 30.56 32.5 31.25 32.5H33.75C34.44 32.5 35 33.06 35 33.75C35 34.44 34.44 35 33.75 35Z'
      fill='black'
    />
    <path
      d='M41.25 35H38.75C38.06 35 37.5 34.44 37.5 33.75C37.5 33.06 38.06 32.5 38.75 32.5H41.25C41.94 32.5 42.5 33.06 42.5 33.75C42.5 34.44 41.94 35 41.25 35Z'
      fill='black'
    />
    <path
      d='M11.25 40H8.75C8.06 40 7.5 39.44 7.5 38.75C7.5 38.06 8.06 37.5 8.75 37.5H11.25C11.94 37.5 12.5 38.06 12.5 38.75C12.5 39.44 11.94 40 11.25 40Z'
      fill='black'
    />
    <path
      d='M18.75 40H16.25C15.56 40 15 39.44 15 38.75C15 38.06 15.56 37.5 16.25 37.5H18.75C19.44 37.5 20 38.06 20 38.75C20 39.44 19.44 40 18.75 40Z'
      fill='black'
    />
    <path
      d='M26.25 40H23.75C23.06 40 22.5 39.44 22.5 38.75C22.5 38.06 23.06 37.5 23.75 37.5H26.25C26.94 37.5 27.5 38.06 27.5 38.75C27.5 39.44 26.94 40 26.25 40Z'
      fill='black'
    />
    <path
      d='M33.75 40H31.25C30.56 40 30 39.44 30 38.75C30 38.06 30.56 37.5 31.25 37.5H33.75C34.44 37.5 35 38.06 35 38.75C35 39.44 34.44 40 33.75 40Z'
      fill='black'
    />
    <path
      d='M41.25 40H38.75C38.06 40 37.5 39.44 37.5 38.75C37.5 38.06 38.06 37.5 38.75 37.5H41.25C41.94 37.5 42.5 38.06 42.5 38.75C42.5 39.44 41.94 40 41.25 40Z'
      fill='black'
    />
  </svg>
)
